import "./StructureHierarchy.module.css";
import Header from "@/reusable_sections/Header";
import StrukturHierarkiHero from "./sections/StrukturHierarkiHero";
import ZonaPPOrganizationalChart from "./sections/ZonaPPOrganizationalChart";
import ViewSwitcherTabs from "./sections/ViewSwitcherTabs";
import Footer from "@/reusable_sections/Footer";
export default function StructureHierarchyPage() {
  return <div>
      <Header />
      <StrukturHierarkiHero />
      <ZonaPPOrganizationalChart />
      <ViewSwitcherTabs />
      <Footer />
    </div>;
}